export default __webpack_public_path__ + "35335a84de2a3da14e25d5bcc49eba06.png";